module.exports = __webpack_public_path__ + "img/assDP.4d07d8f2.svg";